export default __webpack_public_path__ + "static/media/i2.1420f0e8.jpg";